import React from 'react'

import './congratulations.scss'


const messages = [
    'Gratulacje {}!',
    'Jesteś najlepsza, {}!',
    'Great work {}!',
    'Good job {}!',

    "Fantastic work, {}! You’ve really outdone yourself this time!",
    "Congratulations, {}! Your hard work is paying off beautifully!",
    "Well done, {}! You’re an inspiration to everyone around you.",
    "Bravo, {}! Your dedication and effort are truly impressive.",
    "Outstanding job, {}! You’re setting the bar high for everyone else.",
    "Amazing work, {}! Keep shining bright like this!",
    "Kudos, {}! Your commitment is truly commendable.",
    "Hats off to you, {}! What a stellar achievement!",
    "Great job, {}! You’ve proven once again how talented you are.",
    "Exceptional work, {}! You’re making a real difference.",
    "Impressive effort, {}! You should be very proud of yourself.",
    "Wonderful achievement, {}! Your passion shows in everything you do.",
    "Superb, {}! Your hard work has really paid off!",
    "Cheers to you, {}! You deserve all the recognition coming your way.",
    "Excellent job, {}! Your perseverance is inspiring.",
    "Way to go, {}! This is what success looks like.",
    "Congratulations, {}! You’ve earned every bit of this success.",
    "Amazing effort, {}! You’re truly a force to be reckoned with.",
    "Incredible, {}! Your accomplishments speak volumes about your skills.",
    "Well done, {}! You’re a shining example of excellence.",

    "Świetna robota, {}! Naprawdę się postarałaś!",
    "Gratulacje, {}! Twoja praca przynosi niesamowite efekty.",
    "Brawo, {}! Jesteś inspiracją dla wszystkich dookoła.",
    "Doskonale, {}! Twoje zaangażowanie jest godne podziwu.",
    "Rewelacyjna robota, {}! Ustawiasz poprzeczkę bardzo wysoko.",
    "Fantastycznie, {}! Twoje osiągnięcie jest naprawdę imponujące.",
    "Wielkie brawa, {}! Twoja praca zasługuje na uznanie.",
    "Czapki z głów, {}! Co za wspaniały sukces!",
    "Dobra robota, {}! Udowadniasz, jak bardzo jesteś utalentowana.",
    "Wybitnie, {}! Robisz ogromną różnicę swoją pracą.",
    "Gratuluję, {}! Twoja pasja jest widoczna w każdym szczególe.",
    "Niesamowity wysiłek, {}! Powinnaś być z siebie dumna.",
    "Wspaniałe osiągnięcie, {}! Twoje zaangażowanie jest inspirujące.",
    "Super, {}! Twoja ciężka praca się opłaciła!",
    "Brawo, {}! Zasługujesz na każde uznanie.",
    "Doskonała robota, {}! Twoja wytrwałość jest godna podziwu.",
    "Gratulacje, {}! Tak wygląda prawdziwy sukces.",
    "Niesamowite, {}! Twoje osiągnięcia mówią same za siebie.",
    "Wyjątkowo, {}! Jesteś przykładem doskonałości.",
    "Świetna robota, {}! Jesteś prawdziwą inspiracją!",

    "Ottimo lavoro, {}! Hai fatto davvero un lavoro straordinario!",
    "Complimenti, {}! Il tuo impegno sta dando grandi risultati.",
    "Bravissima, {}! Sei un esempio di dedizione e talento.",
    "Fantastico, {}! Il tuo lavoro è davvero ispirante.",
    "Congratulazioni, {}! Hai raggiunto un traguardo eccezionale.",
    "Eccellente lavoro, {}! Stai dimostrando un talento incredibile.",
    "Grande, {}! Il tuo successo è assolutamente meritato.",
    "Molto bene, {}! Hai superato ogni aspettativa.",
    "Sei un’ispirazione, {}! Continua così!",
    "Perfetto, {}! Il tuo impegno e la tua passione sono ineguagliabili.",

    "Jak mawiał trener Piechniczek: „Jeśli chcesz grać w piłkę, musisz myśleć jak piłka”! Brawo {}!",
    "Jak mawia trener Piechniczek „Prawdziwy sportowiec zakłada pokrowiec”! Brawo {}!",
    "Jak mawia trener Piechniczek „Skończyła się szatnia – zaczęła się trawa”! Brawo {}!",
    "Jak mawiał trener Piechniczek „Czasami się zawsze wygrywa, a czasami nigdy”! Brawo {}!",
    "Jak mawiał trener Piechniczek „Czasem tak się zdarza, że piłka leci do piłkarza”! Brawo {}!",
    "Jak mawiał trener Piechniczek „Najważniejsze, że wziąłem buty”! Brawo {}!",
    "Jak mawiał trener Piechniczek „Nie da się drugi raz wykorzystać niewykorzystanej sytuacji”! Brawo {}!",
    "Nie możemy podcinać gałęzi na której sramy we własne gniazdo! Brawo {}!",
    "Pupcia rubcia salcesonik helou belou w dupę słonik!",
    "Weź ten pająk i go ugryź, więc brawo {}!",
    "Trener Piechniczek mawiał: „To było praktycznie, kurwa, trudne”, więc brawo {}!",

    // Tytus, Romek i A'Tomek (Henryk Jerzy Chmielewski)
    "Jak mawiał Tytus de Zoo: „Człowiek to brzmi dumnie, ale małpa trenuje ciężej”! Brawo {}!",
    "Tytus de Zoo powiedziałby: „Bez treningu nie ma ewolucji”! A ty, {}? Ewoluujesz!",
    "Romek i A'Tomek wołają: „{}! Zrobiłaś to, co inni tylko planują!”",
    "Tytus de Zoo kiwa głową z uznaniem: „Wprawdzie nie jestem człowiekiem, ale nawet ja wiem – brawo, {}!”",

    // Kajko i Kokosz (Janusz Christa)
    "Jak mawiał Kokosz: „Lepiej pot na sali niż wróg na karku”! Brawo {}!",
    "Kajko krzyczy: „Hej ho, {}! Nieźle walnęłaś tę sztangę!”",
    "Kokosz mruczy z zadowoleniem: „Kto ćwiczy, ten nie rdzewieje. Patrz na {}!”",
    "Mistrz Wiślak pochwaliłby: „Dobry wojownik to wytrenowany wojownik – a ty, {}, trenujesz jak bohater!”",

    // Thorgal (Jean Van Hamme / Grzegorz Rosiński)
    "Thorgal powiedziałby: „Siła nie pochodzi z mięśni, lecz z woli – a ty, {}, masz jej dosyć!”",
    "Aaricia szepnęłaby do Thorgala: „Patrz, jak {} trenuje. To wojowniczka godna sag!”",
    "Jak napisano w Sadze Thorgala: „Ten, kto nie odpuszcza, zdobywa Midgard”. Nie odpuściłaś, {}!",

    // Kapitan Żbik (Władysław Krupka)
    "Kapitan Żbik zameldował: „Obywatelko {}, akcja zakończona sukcesem. Brawo!”",
    "Kapitan Żbik mówi: „Dyscyplina i wytrwałość – to twoja broń, {}. Cel osiągnięty!”",

    // Asteriks (Goscinny / Uderzo – polska edycja)
    "Asteriks krzyczy: „Przez Teutates! {} jest niepokonana!”",
    "Obeliks wrzeszczy: „Oni są szaleni, ci… którzy nie trenują jak {}!”",
    `Panoramiks kiwa głową: „Magiczny napój nie jest potrzebny – {}  ma wystarczająco dużo siły!”`,

    // How To with John Wilson
    `John Wilson zauważył, filmując przypadkowych przechodniów, że większość ludzi nigdy nie kończy tego, co zaczyna. Ty, {}, jesteś wyjątkiem.`,
    `Jak odkrył John Wilson podczas badania rusztowań na Manhattanie: czasem wystarczy pokryć wszystko pianką i po prostu działać. Zadziałałaś, {}!`,
    `John Wilson zrobiłby o tym odcinek: „Jak skończyć trening”. Ale ty już wiesz, {}.`,
    `John Wilson nagrałby teraz zbliżenie na twoje buty sportowe i zagrał smutną jazzową muzykę. Ale to byłby odcinek o kimś innym. Brawo, {}!`,

    // Adventure Time
    `MATHEMATICAL, {}!`,
    `Co za czas?! CZAS NA TRENING! I {} go skończyła!`,
    `Jake the Dog powiedziałby: „Bycie do niczego w czymś to pierwszy krok do bycia jako tako niezłym”. Ty już dawno przeszłaś ten etap, {}!`,
    `BMO mówi: „Jestem szczęśliwy, że żyję i że znam {}!”`,
    `Finn the Human krzyczy: „Algebraiczne, {}! To było totalnie algebraiczne!”`,
    `Ice King płacze ze wzruszenia i nikt nie wie dlaczego. Brawo {}!`,

    // Steven Universe
    `Garnet kiwa głową. Garnet nigdy się nie myli. Brawo, {}.`,
    `Steven Universe powiedziałby: „Jesteśmy Kryształowymi Klejnotami – i ty też, {}!”`,
    `Greg Universe mawiał: „Gdyby każdy kotlet był idealny, nie byłoby hot dogów”. Ty jesteś idealnym hot dogiem, {}.`,
    `Amethyst wrzeszczy: „{} jest NAJLEPSZA i nikt mi tego nie wyperswaduje!”`,
    `Pearl ze łzami w oczach: „Wiedziałam, że dasz radę, {}. Zawsze w to wierzyłam.”`,

    // Nathan Fillion
    `Kapitan Mal Reynolds powiedziałby: „I aim to misbehave” – ale ty, {}, celujesz w rekordy i trafiasz!`,
    `Shiny, {}! Absolutely shiny.`,
    `Mal Reynolds kiwa głową: „You can't stop the signal” – ani {} na treningu.`,
    `Castle powiedziałby: „To jest albo najlepszy trening ever, albo coś jeszcze lepszego”. Brawo, {}!`,
    `Nathan Fillion patrzy prosto w kamerę i mówi: „{}. Impressed.”`,

    // Too Many Cooks
    `TOO MANY COOKS! Ale tylko jedno {}!`,
    `Too many cooks spoil the broth – ale jest tylko jedna {} i właśnie skończyła trening!`,
    `T… T… T… TOO MANY COOKS! Za to {}? W sam raz.`,
]

const emojis = [
    "🎉", "🎊", "✨", "🌟", "🏆", "🥇", "🥳", "👏", "🙌", "💐", "🎁", "🎀", "🎖️", "💖", "❤️",
    "💕", "💞", "💓", "💗", "💘", "💝", "😍", "🥰", "😊", "😁", "😄", "😃", "😆", "😎", "🤩",
    "🤗", "💌", "🌈", "🎶", "🌸", "🌺", "🌹", "🐎", "🐴", "🏇", "🐾", "🦄", "🌻", "🌞", "🌟",
    "💎", "🍾", "🎈", "🎂", "🍰", "🎵", "🎺", "🎷", "🎸",
]


export default function Congratulations({count, username, onClose}) {
    const message = React.useRef(getRandomElement(messages).replace('{}', username)).current
    const emoji = React.useRef(getRandomElement(emojis)).current

    React.useEffect(() => {
        return animateConfetti()
    }, [])

    return <div className="congratulations" onClick={onClose}>
        <div className="congratulations__inner">
            <div className="congratulations__hero">
                {emoji}
            </div>
            <div>
                {message}
            </div>
            <div>
                +{count} punktów!
            </div>
        </div>
    </div>
}


function getRandomElement(arr) {
    const randomIndex = Math.floor(Math.random() * arr.length)
    return arr[randomIndex]
}


function animateConfetti() {
    let stop = false
    const confettiCanvas = document.getElementById('confettiCanvas');
    const balloonCanvas = document.getElementById('balloonCanvas');
    const confettiCtx = confettiCanvas.getContext('2d');
    const balloonCtx = balloonCanvas.getContext('2d');
    confettiCanvas.width = balloonCanvas.width = window.innerWidth;
    confettiCanvas.height = balloonCanvas.height = window.innerHeight;

    let confetti = [];
    function createConfetti() {
        confetti = [];
        for (let i = 0; i < 200; i++) {
            confetti.push({
                x: Math.random() * confettiCanvas.width,
                y: Math.random() * confettiCanvas.height - confettiCanvas.height,
                r: Math.random() * 6 + 2,
                color: `hsl(${Math.random() * 360}, 100%, 70%)`,
                tilt: Math.random() * 10 - 5,
                speed: Math.random() * 2 + 1,
            });
        }
    }

    function drawConfetti() {
        confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
        confetti.forEach((c) => {
            confettiCtx.beginPath();
            confettiCtx.arc(c.x, c.y, c.r, 0, Math.PI * 2);
            confettiCtx.fillStyle = c.color;
            confettiCtx.fill();
            c.y += c.speed;
            c.tilt += Math.random() * 0.1 - 0.05;

            if (c.y > confettiCanvas.height) c.y = -c.r;
        });
    }

    let balloons = [];
    function createBalloons() {
        for (let i = 0; i < 10; i++) {
            balloons.push({
                x: Math.random() * balloonCanvas.width,
                y: balloonCanvas.height + Math.random() * 100,
                r: Math.random() * 20 + 10,
                color: `hsl(${Math.random() * 360}, 100%, 70%)`,
                vy: Math.random() * 2 + 1,
            });
        }
    }

    function drawBalloons() {
        balloonCtx.clearRect(0, 0, balloonCanvas.width, balloonCanvas.height);
        balloons.forEach((b, i) => {
            balloonCtx.beginPath();
            balloonCtx.arc(b.x, b.y, b.r, 0, Math.PI * 2);
            balloonCtx.fillStyle = b.color;
            balloonCtx.fill();
            b.y -= b.vy;
            if (b.y + b.r < 0) balloons.splice(i, 1);
        });
    }

// Animations
    function animate() {
        if (stop) {return}
        drawConfetti()
        drawBalloons()
        requestAnimationFrame(animate)
    }

    createConfetti();
    createBalloons()
    animate()
    return () => {
        stop = true
        confettiCtx.clearRect(0, 0, confettiCanvas.width, confettiCanvas.height);
        balloonCtx.clearRect(0, 0, balloonCanvas.width, balloonCanvas.height);
    }
}
